<template>
  <div
    ref="kt_modal_adicionais_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/abstract/abs027.svg"
              class="me-2"
            />Adicionais
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicional(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <ConsultarAdicional
            ref="ConsultarAdicional"
            @adicionarAdicional="adicionarAdicional"
            @editarAdicional="editarAdicional"
            @selecionarAdicional="selecionarAdicional"
            @exibirAdicionalGrupo="exibirAdicionalGrupo"
          ></ConsultarAdicional>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicional(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarAdicional"
    ref="kt_modal_adicionais_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idAdicional === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Adicional
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Adicional
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarAdicional(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarAdicional
            @cancelarAdicional="modalEditarAdicional"
            @confirmarAdicional="confirmarAdicional"
            :idAdicional="idAdicional"
          ></EditarAdicional>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirConsultarAdicionalGrupo"
    ref="kt_modal_adicionais_grupo_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_grupo_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/abstract/abs029.svg"
              class="me-2"
            />Adicionais - Grupos
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicionalGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <ConsultarAdicionalGrupo
            ref="ConsultarAdicionalGrupo"
            @adicionarAdicionalGrupo="adicionarAdicionalGrupo"
            @editarAdicionalGrupo="editarAdicionalGrupo"
            @exibirAdicionalGrupoItem="exibirAdicionalGrupoItem"
            :idAdicional="idAdicional"
          ></ConsultarAdicionalGrupo>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicionalGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarAdicionalGrupo"
    ref="kt_modal_adicionais_grupo_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_grupo_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idAdicionalGrupo === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Grupo
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Grupo
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarAdicionalGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarAdicionalGrupo
            @cancelarAdicionalGrupo="modalEditarAdicionalGrupo"
            @confirmarAdicionalGrupo="confirmarAdicionalGrupo"
            :idAdicional="idAdicional"
            :idAdicionalGrupo="idAdicionalGrupo"
          ></EditarAdicionalGrupo>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="this.exibirConsultarAdicionalGrupoItem"
    ref="kt_modal_adicionais_grupo_item_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_grupo_item_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/abstract/abs030.svg"
              class="me-2"
            />Adicionais - Itens
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicionalGrupoItem(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <ConsultarAdicionalGrupoItem
            ref="ConsultarAdicionalGrupoItem"
            @adicionarAdicionalGrupoItem="adicionarAdicionalGrupoItem"
            @editarAdicionalGrupoItem="editarAdicionalGrupoItem"
            :idAdicionalGrupo="idAdicionalGrupo"
          ></ConsultarAdicionalGrupoItem>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="modalConsultarAdicionalGrupoItem(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarAdicionalGrupoItem"
    ref="kt_modal_adicionais_grupo_item_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_adicionais_grupo_item_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.idAdicionalGrupoItem === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Item
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Item
          </h3>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarAdicionalGrupoItem(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarAdicionalGrupoItem
            @cancelarAdicionalGrupoItem="modalEditarAdicionalGrupoItem"
            @confirmarAdicionalGrupoItem="confirmarAdicionalGrupoItem"
            :idAdicionalGrupo="idAdicionalGrupo"
            :idAdicionalGrupoItem="idAdicionalGrupoItem"
          ></EditarAdicionalGrupoItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarAdicional from "@/views/adicionais/Consultar.vue";
import EditarAdicional from "@/views/adicionais/Editar.vue";
import ConsultarAdicionalGrupo from "../adicionaisgrupo/Consultar.vue";
import EditarAdicionalGrupo from "@/views/adicionaisgrupo/Editar.vue";
import ConsultarAdicionalGrupoItem from "../adicionaisgrupoitens/Consultar.vue";
import EditarAdicionalGrupoItem from "@/views/adicionaisgrupoitens/Editar.vue";
import {
  hideModal,
  showModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalAdicional", "selecionarAdicional"],
  components: {
    ConsultarAdicional,
    EditarAdicional,
    ConsultarAdicionalGrupo,
    EditarAdicionalGrupo,
    ConsultarAdicionalGrupoItem,
    EditarAdicionalGrupoItem,
  },
  methods: {
    //Emits ConsultarAdicional
    modalConsultarAdicional(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalAdicional", false);
      }
      this.exibirConsultarAdicional = exibir;
    },
    adicionarAdicional() {
      this.idAdicional = 0;
      this.modalEditarAdicional(true);
    },
    editarAdicional(id) {
      this.idAdicional = id;
      this.modalEditarAdicional(true);
    },
    selecionarAdicional(adicional) {
      this.$emit("selecionarAdicional", adicional);
      hideModal(this.$refs.kt_modal_adicionais_consultar);
    },
    exibirAdicionalGrupo(id) {
      this.idAdicional = id;
      this.modalConsultarAdicionalGrupo(true);
    },
    //Emits EditarAdicional
    modalEditarAdicional(exibir) {
      this.exibirEditarAdicional = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_adicionais_editar");
          },
          /*close*/ () => {
            this.modalEditarAdicional(false);
          }
        );
      }
    },
    confirmarAdicional() {
      this.modalEditarAdicional(false);
      hideModal(this.$refs.kt_modal_adicionais_editar);
      this.$refs.ConsultarAdicional.loadData();
    },
    //Emits ConsultarAdicionalGrupo
    modalConsultarAdicionalGrupo(exibir) {
      this.exibirConsultarAdicionalGrupo = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_grupo_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarAdicionaisGrupos");
          },
          /*close*/ () => {
            this.modalConsultarAdicionalGrupo(false);
          }
        );
      }
    },
    adicionarAdicionalGrupo() {
      this.idAdicionalGrupo = 0;
      this.modalEditarAdicionalGrupo(true);
    },
    editarAdicionalGrupo(id) {
      this.idAdicionalGrupo = id;
      this.modalEditarAdicionalGrupo(true);
    },
    exibirAdicionalGrupoItem(id) {
      this.idAdicionalGrupo = id;
      this.modalConsultarAdicionalGrupoItem(true);
    },
    //Emits EditarAdicionalGrupo
    modalEditarAdicionalGrupo(exibir) {
      this.exibirEditarAdicionalGrupo = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_grupo_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_adicionais_grupo_editar");
          },
          /*close*/ () => {
            this.modalEditarAdicionalGrupo(false);
          }
        );
      }
    },
    confirmarAdicionalGrupo() {
      this.modalEditarAdicionalGrupo(false);
      hideModal(this.$refs.kt_modal_adicionais_grupo_editar);
      showModal(this.$refs.kt_modal_adicionais_grupo_consultar);
      this.$refs.ConsultarAdicionalGrupo.loadData();
    },
    //Emits ConsultarAdicionalGrupoItem
    modalConsultarAdicionalGrupoItem(exibir) {
      this.exibirConsultarAdicionalGrupoItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_grupo_item_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarAdicionaisItens");
          },
          /*close*/ () => {
            this.modalConsultarAdicionalGrupoItem(false);
          }
        );
      }
    },
    adicionarAdicionalGrupoItem() {
      this.idAdicionalGrupoItem = 0;
      this.modalEditarAdicionalGrupoItem(true);
    },
    editarAdicionalGrupoItem(id) {
      this.idAdicionalGrupoItem = id;
      this.modalEditarAdicionalGrupoItem(true);
    },
    //Emits EditarAdicionalGrupoItem
    modalEditarAdicionalGrupoItem(exibir) {
      this.exibirEditarAdicionalGrupoItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_grupo_item_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_adicionais_grupo_item_editar");
          },
          /*close*/ () => {
            this.modalEditarAdicionalGrupoItem(false);
          }
        );
      }
    },
    confirmarAdicionalGrupoItem() {
      this.modalEditarAdicionalGrupoItem(false);
      hideModal(this.$refs.kt_modal_adicionais_grupo_item_editar);
      this.$refs.ConsultarAdicionalGrupoItem.loadData();
    },
  },
  mounted() {
    this.modalConsultarAdicional(true);
  },
  data() {
    return {
      idAdicional: 0,
      idAdicionalGrupo: 0,
      idAdicionalGrupoItem: 0,
      exibirConsultarAdicional: false,
      exibirEditarAdicional: false,
      exibirConsultarAdicionalGrupo: false,
      exibirEditarAdicionalGrupo: false,
      exibirConsultarAdicionalGrupoItem: false,
      exibirEditarAdicionalGrupoItem: false,
    };
  },
};
</script>

<style></style>
